import { TestCard, TestType } from "@app/provider/testData/types";
import { BusinessUnits, DrawRequestTimeslots } from "./drawRequest";
import { MessageDescriptor } from "react-intl";

export enum MobilePhlebotomyStatus {
  DRAFTED = "DRAFTED",
  AVAILABLE = "AVAILABLE",
  CLAIMED = "CLAIMED",
  PUBLISHED = "PUBLISHED",
  ASSIGNED = "ASSIGNED",
  SCHEDULED = "SCHEDULED",
  ON_THE_WAY = "ON_THE_WAY",
  ON_SITE = "ON_SITE",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

export interface Physician {
  limsId: number;
  displayName?: string;
  firstName?: string;
  lastName?: string;
}

interface ClinicAdress {
  state?: string;
}

export interface Clinic {
  limsId: number;
  name?: string;
  settings?: {
    testSettings?: [TestSetting];
  };
  address?: ClinicAdress;
}

export interface TestSetting {
  testType: TestType;
  nevaEnabled: boolean;
}

export interface ShippingAddress {
  countryCode?: string;
  city?: string;
  state?: string;
  street?: string;
  street1?: string | null;
  street2?: string | null;
  zipCode?: string;
}

export interface DrawRequest extends DrawRequestTimeslots {
  uid?: string;
  jobStart?: string;
  jobEnd?: string;
  jobStatus: MobilePhlebotomyStatus;
  jobTypes?: string[];
  note?: string;
  shippingAddress?: ShippingAddress;
  jobTimezone?: string;
}

export interface ResultDocumentsInfo {
  documentUid?: string;
  documentReferenceId?: number;
}

export enum CancerStage {
  I = "I",
  II = "II",
  IIA = "IIA",
  IIB = "IIB",
  IIC = "IIC",
  III = "III",
  IIIA = "IIIA",
  IIIB = "IIIB",
  IIIC = "IIIC",
  IV = "IV",
  OTHER = "OTHER",
}

export interface SignateraClinicalInfo {
  __typename?: "SignateraClinicalInfo";
  cancerType?: string;
  cancerStage?: CancerStage;
  dateOfSurgery?: string;
}

export interface AlteraClinicalInfo {
  __typename?: "AlteraClinicalInfo";
  cancerType?: string;
  dateOfSurgery?: string;
}

export interface LatitudeClinicalInfo {
  __typename?: "LatitudeClinicalInfo";
  cancerType?: string;
  dateOfSurgery?: string;
}

export type ClinicalInfo =
  | SignateraClinicalInfo
  | AlteraClinicalInfo
  | LatitudeClinicalInfo;

export interface TestDetailsRecord extends TestCard {
  physician: Physician;
  drawRequest?: DrawRequest;
  limsId?: number;
  limsIds?: [string];
  businessUnit: BusinessUnits;
  description?: string;
  jobTypesConcatenated: string;
  resultDocumentsInfo: ResultDocumentsInfo[];
  nevaSessionToken?: string;
  clinicalInfo?: ClinicalInfo;
}

export enum HEAP_EVENTS {
  upp_viewresultpdf_failure = "upp_viewresultpdf_failure",
  upp_viewresultpdf_success = "upp_viewresultpdf_success",
  upp_sampledraw_pref = "upp_sampledraw_pref",
  upp_sampledraw_mp_appt_failure = "upp_sampledraw_mp_appt_failure",
  upp_sampledraw_mp_modifyappt_failure = "upp_sampledraw_mp_modifyappt_failure",
  upp_sampledraw_mp_cancelappt_failure = "upp_sampledraw_mp_cancelappt_failure",
  upp_organiclogin_success = "upp_organiclogin_success",
  upp_organiclogin_failure = "upp_organiclogin_failure",
  upp_tokenizedlogin_success = "upp_tokenizedlogin_success",
  upp_tokenizedlogin_failure = "upp_tokenizedlogin_failure",
  upp_click_testcardcta = "upp_click_testcardcta",
  upp_communication_pref = "upp_communication_pref",
  upp_click_gis = "upp_click_gis",
  upp_view_gis_entry = "upp_view_gis_entry",
  upp_click_gis_entry_login = "upp_click_gis_entry_login",
  upp_click_gis_entry_createaccount = "upp_click_gis_entry_createaccount",
  upp_click_gis_entry_guest = "upp_click_gis_entry_guest",
  upp_view_gis_triage = "upp_view_gis_triage",
  upp_gis_triage_autoroute = "upp_gis_triage_autoroute",
  upp_gis_triage_classification = "upp_gis_triage_classification",
  upp_view_gis_order_select = "upp_view_gis_order_select",
  upp_gis_order_select = "upp_gis_order_select",
  upp_click_patientprofile = "upp_click_patientprofile",
  upp_click_testhistory = "upp_click_testhistory",
  upp_click_home = "upp_click_home",
  upp_core_share_feedback_menu_click = "upp_core_share_feedback_menu_click",
  upp_core_share_feedback_submit = "upp_core_share_feedback_submit",
  upp_click_contactnatera = "upp_click_contactnatera",
  upp_core_forgot_email_click = "upp_core_forgot_email_click",
  upp_video25perc = "upp_video25perc",
  upp_video50perc = "upp_video50perc",
  upp_video75perc = "upp_video75perc",
  upp_video100perc = "upp_video100perc",
  upp_simpleorder_started = "upp_simpleorder_started",
  upp_simpleorder_editpersonalinfo = "upp_simpleorder_editpersonalinfo",
  upp_simpleorder_ethinicity = "upp_simpleorder_ethinicity",
  upp_simpleorder_partnerconsentyes = "upp_simpleorder_partnerconsentyes",
  upp_simpleorder_partnerconsentno = "upp_simpleorder_partnerconsentno",
  upp_simpleorder_fetalsex = "upp_simpleorder_fetalsex",
  upp_simpleorder_payment = "upp_simpleorder_payment",
  upp_simpleorder_insurance = "upp_simpleorder_insurance",
  upp_simpleorder_firstinsurance = "upp_simpleorder_firstinsurance",
  upp_simpleorder_secondinsurance = "upp_simpleorder_secondinsurance",
  upp_simpleorder_costestimate = "upp_simpleorder_costestimate",
  upp_simpleorder_selfpay = "upp_simpleorder_selfpay",
  upp_fetalsexreporting_click = "upp_fetalsexreporting_click",
  upp_fetalsexreporting_downloadcta = "upp_fetalsexreporting_downloadcta",
  upp_fetalsexreporting_copy = "upp_fetalsexreporting_copy",
  upp_fetalsex_hide_on_PDF = "upp_fetalsex_hide_on_PDF",
  upp_fetalsex_view_on_PDF = "upp_fetalsex_view_on_PDF",
  upp_mp_guestflow = "upp_mp_guestflow",
  upp_mp_click_create_account = "upp_mp_click_create_account",
  upp_patientinfo_edit = "upp_patientinfo_edit",
  upp_secondarycard_click = "upp_secondarycard_click",
  upp_empower_risk_alert_banner = "upp_empower_risk_alert_banner",
  upp_empower_risk_alert_click = "upp_empower_risk_alert_click",
  upp_viewrenewal_page = "upp_viewrenewal_page",
  upp_renewal_homepage_signatera_click = "upp_renewal_homepage_signatera_click",
  upp_renewal_mp_signatera_click = "upp_renewal_mp_signatera_click",
  download_altera_results_guide = "download_altera_results_guide",
  download_empower_results_guide = "download_empower_results_guide",
  download_signatera_results_guide = "download_signatera_results_guide",
  upp_renewal_signatera_yes_interested = "upp_renewal_signatera_yes_interested",
  upp_renewal_signatera_not_interested = "upp_renewal_signatera_not_interested",
  upp_public_url_zip_search = "upp_public_url_zip_search",
  upp_empower_risk_yes_interested = "upp_empower_risk_yes_interested",
  upp_empower_risk_not_interested = "upp_empower_risk_not_interested",
  upp_pb_click_language = "upp_pb_click_language",
  upp_pb_click_view_estimate = "upp_pb_click_view_estimate",
  upp_pb_click_estimate_got_it = "upp_pb_click_estimate_got_it",
  upp_pb_click_pay_cash = "upp_pb_click_pay_cash",
  upp_pb_click_save_payment = "upp_pb_click_save_payment",
  upp_pb_click_compcare = "upp_pb_click_compcare",
  upp_pb_click_survey_yes = "upp_pb_click_survey_yes",
  upp_pb_click_survey_no = "upp_pb_click_survey_no",
  upp_pb_click_create_account = "upp_pb_click_create_account",
  upp_pb_click_view_promptpay = "upp_pb_click_view_promptpay",
  upp_pb_click_insurance = "upp_pb_click_insurance",
  upp_pb_click_insurance_yes = "upp_pb_click_insurance_yes",
  upp_pb_click_insurance_no = "upp_pb_click_insurance_no",
  upp_language = "upp_language",
  upp_click_compcare_tile = "upp_click_compcare_tile",

  //Postbill-Billing Center Events
  upp_view_billingcenter_card = "upp_view_billingcenter_card",
  upp_click_billingcenter_card = "upp_click_billingcenter_card",
  upp_click_billingcenter = "upp_click_billingcenter",
  upp_click_mybills_tab = "upp_click_mybills_tab",
  upp_view_mybills_tab = "upp_view_mybills_tab",
  upp_click_viewpaymenthistory = "upp_click_viewpaymenthistory",
  upp_click_billing_history_tab = "upp_click_billing_history_tab",
  upp_view_billing_history_tab = "upp_view_billing_history_tab",
  upp_click_billing_help_tab = "upp_click_billing_help_tab",
  upp_view_billing_help_tab = "upp_view_billing_help_tab",
  upp_click_billing_inprocess = "upp_click_billing_inprocess",
  upp_view_billing_readytopay = "upp_view_billing_readytopay",
  upp_click_billing_readytopay = "upp_click_billing_readytopay",
  upp_click_history_payments = "upp_click_history_payments",
  upp_click_history_payment_plans = "upp_click_history_payment_plans",
  upp_click_view_receipt = "upp_click_view_receipt",
  upp_click_billing_help_contact_us = "upp_click_billing_help_contact_us",
  upp_click_billing_help_wh = "upp_click_billing_help_wh",
  upp_click_billing_help_oh = "upp_click_billing_help_oh",
  upp_click_billing_help_onc = "upp_click_billing_help_onc",
  upp_view_tokenizedlogin = "upp_view_tokenizedlogin",
  upp_click_billing_payment_review = "upp_click_billing_payment_review",
  upp_click_billing_payment_continuetopay = "upp_click_billing_payment_continuetopay",
  upp_click_billing_payment_paynow = "upp_click_billing_payment_paynow",
  upp_view_billing_payment_confirmation = "upp_view_billing_payment_confirmation",
  upp_billing_payment_abandoned = "upp_billing_payment_abandoned",
  upp_billing_payment_failedpayment = "upp_billing_payment_failedpayment",
  upp_click_billing_manage_payment_plan = "upp_click_billing_manage_payment_plan",
  upp_click_billing_payment_plan_pay_full_balance = "upp_click_billing_payment_plan_pay_full_balance",
  upp_click_billing_payment_plan_edit_payment_method = "upp_click_billing_payment_plan_edit_payment_method",
  upp_public_billing_order_match_success = "upp_public_billing_order_match_success",
  upp_public_billing_order_match_failure = "upp_public_billing_order_match_failure",

  //UPS Events
  // the reason we don't keep the prefix as upp_ is that PMs are creating the analytic dashboards and they want to find the event easily without going through setting filter for notification_type = pre-bill | postbill.
  // however, this approach introduces a naming collision problem: when a new  project is created, we end up needing to define additional mapping like  `project1_view_tokenizedlogin`
  ups_view_tokenizedlogin = "ups_view_tokenizedlogin",
  ups_click_update_payment_method = "ups_click_update_payment_method",
  ups_click_billing_payment_continuetopay = "ups_click_billing_payment_continuetopay",
  ups_click_billing_payment_paynow = "ups_click_billing_payment_paynow",
  ups_view_billing_payment_confirmation = "ups_view_billing_payment_confirmation",
  ups_billing_payment_failedpayment = "ups_billing_payment_failedpayment",
  ups_linkexpired = "ups_linkexpired",
  ups_redirect_incompleteaccount = "ups_redirect_incompleteaccount",

  //Patient Education Events
  upp_prenataled_landing = "upp_prenataled_landing",
  upp_prenataled_begin = "upp_prenataled_begin",
  upp_prenataled_pano_next = "upp_prenataled_pano_next",
  upp_prenataled_horizon_next = "upp_prenataled_horizon_next",
  upp_prenataled_submit = "upp_prenataled_submit",
  upp_prenataled_pano_interest = "upp_prenataled_pano_interest",
  upp_prenataled_horizon_interest = "upp_prenataled_horizon_interest",
  upp_prenataled_pano_video_play = "upp_prenataled_pano_video_play",
  upp_prenataled_horizon_video_play = "upp_prenataled_horizon_video_play",
  upp_prenataled_pano_video_25 = "upp_prenataled_pano_video_25",
  upp_prenataled_pano_video_50 = "upp_prenataled_pano_video_50",
  upp_prenataled_pano_video_75 = "upp_prenataled_pano_video_75",
  upp_prenataled_pano_video_100 = "upp_prenataled_pano_video_100",
  upp_prenataled_horizon_video_25 = "upp_prenataled_horizon_video_25",
  upp_prenataled_horizon_video_50 = "upp_prenataled_horizon_video_50",
  upp_prenataled_horizon_video_75 = "upp_prenataled_horizon_video_75",
  upp_prenataled_horizon_video_100 = "upp_prenataled_horizon_video_100",
}

export enum SignateraRenewalInterestSource {
  email = "email",
  UPP = "UPP",
}

export enum HeapEventLocation {
  accountCreation = "accountCreation",
  patientProfile = "patientProfile",

  //On Client side:
  burgerMenu = "Burger Menu",
  horizontalMenu = "Horizontal Menu",
  resultDetailPage = "Result Detail Page",
  mp_flow_initiation_page = "MP_flow_initiation_page",
  mp_dob_page = "MP_DOB_page",
  unable_to_verify_mp_page = "Unable_to_verify_MP_page",
  unable_to_verify_unlock_page = "Unable_to_verify_Unlock_page",
  unable_to_schedule_page = "Unable_to_schedule_page",
  consider_before_schedule_pop_up = "Consider_before_schedule_pop_up",
  main_menu = "Main_menu",
  verification_unlock_page = "Verification_unlock_page",
  personal_info_mp_page = "Personal_info_MP_page",
  verification_account_creation_page = "Verification_account_creation_page",
  unable_to_verify_account_creation_page = "Unable_to_verify_account_creation_page",
  broken_link_error = "Broken_link_Error",
  account_activated_error = "Account_activated_Error",
  linking_error = "Linking_Error",
  update_info_error = "Update_info_Error",
  reset_password_error = "Reset_password_Error",
  gis_public_entry_page = "GIS_Public_Entry_page",
  gis_triage_page = "GIS_Triage_page",
  gis_order_select_page = "GIS_Order_Select_page",
}

export enum HeapVideoContentType {
  renasightPositive = "Renasight_Positive",
  renasightNegative = "Renasight_Negative",
  renasightCarrier = "Renasight_Carrier",
  horizonSimpleOrder = "Horizon_SimpleOrder",
  panoramaSimpleOrder = "Panorama_SimpleOrder",
  prosperaIncreasedRisk = "Prospera_IncreasedRisk",
  prosperaDecreasedRisk = "Prospera_DecreasedRisk",
  prosperaHeartOrLung = "Prospera_HeartOrLung",
  horizonTaySachs = "Horizon_TaySachs",
  horizonDBMuscularDystrophy = "Horizon_DBMuscularDystrophy",
  horizonFragileX = "Horizon_FragileX",
  horizonSMA = "Horizon_SMA",
  horizonCysticFibrosis = "Horizon_CysticFibrosis",
  sampleCollectionSaliva = "SampleCollection_Saliva",
}

export interface HeapVideoOrderData {
  public_order_uid: string;
  lims_clinic_id?: number;
}

export enum HeapDrawRequestFlow {
  guest = "guest",
  account = "account",
  public = "public",
}

export enum DrawCoordinator {
  NATERA = "Natera",
  CLINIC = "clinic",
}

export interface HeapProps {
  business_unit?: string;
  identity?: string;
  test_name?: string;
  lims_clinic_id?: string | number;
  flow?: HeapDrawRequestFlow;
  draw_coordinator?: DrawCoordinator;
}

export type IntlMessage = { [key: string]: MessageDescriptor };
